import { render, staticRenderFns } from "./TourHome.vue?vue&type=template&id=f5c15bb4&scoped=true"
import script from "./TourHome.vue?vue&type=script&lang=js"
export * from "./TourHome.vue?vue&type=script&lang=js"
import style0 from "./TourHome.vue?vue&type=style&index=0&id=f5c15bb4&prod&lang=scss&scoped=true"
import style1 from "./TourHome.vue?vue&type=style&index=1&id=f5c15bb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c15bb4",
  null
  
)

export default component.exports